import React, { useEffect, useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Typography,
} from "@material-ui/core";
import _ from "lodash";

import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import SwitchCommon from "../../../../components/switches/SwitchCommon";
import TextfieldDefaultNew from "../../../../components/textField/TextfieldDefaultNew";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { useForm } from "react-hook-form";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import { INTEGER_NUMBER_PATTERN } from "../../../../utils/consts";

interface FormData {
  cutOfPrice: string;
  minOrderPrice: string;
  pricePerUnit: string;
  daily_limits: any;
  name: string;
  expire_days: number;
}

export interface StrategyAddEditModalProps {
  isOpen: any;
  setIsOpen: any;
  handleCreateNewStrategy: any;
  isLoadingButton: any;
  isEdit: any;
  isDuplicate: any;
  handleReset: any;
}

const input = [
  {
    id: "24947d01-9fd2-4d2e-b38b-c918851eefe1",
    isActive: true,
    groups: [
      {
        groupIndex: 0,
        id: "3f65b62e-3109-4eae-bd6e-e0c77b62204c",
        members: [
          {
            groupId: "3f65b62e-3109-4eae-bd6e-e0c77b62204c",
            id: "4397bbb5-6b9b-481d-a9c7-dbd08a460237",
            memberId: "1952",
            memberType: "ITEM",
          },
        ],
      },
      {
        groupIndex: 1,
        id: "80ab1b97-a001-47b1-8bdf-9cbc700535c0",
        members: [
          {
            groupId: "80ab1b97-a001-47b1-8bdf-9cbc700535c0",
            id: "57e58eee-644a-486f-ab67-19f8e86ec874",
            memberId: "1951",
            memberType: "ITEM",
          },
          {
            groupId: "80ab1b97-a001-47b1-8bdf-9cbc700535c0",
            id: "92952fe7-5465-4775-9410-5219efd086f9",
            memberId: "1950",
            memberType: "ITEM",
          },
        ],
      },
    ],
  },
  {
    id: "58f5c338-e870-4b78-996b-fd97360c2bb7",
    isActive: false,
    groups: [
      {
        groupIndex: 0,
        id: "4bd82d48-34a4-4674-9509-88bf8f2ce383",
        members: [
          {
            groupId: "4bd82d48-34a4-4674-9509-88bf8f2ce383",
            id: "3cb3f66a-7e2c-411a-8e9c-382ff365b391",
            memberId: "1943",
            memberType: "ITEM",
          },
          {
            groupId: "4bd82d48-34a4-4674-9509-88bf8f2ce383",
            id: "8e3029ec-5d92-4e0e-8b89-df98e70df0c6",
            memberId: "1944",
            memberType: "ITEM",
          },
          {
            groupId: "4bd82d48-34a4-4674-9509-88bf8f2ce383",
            id: "b787e2e5-0030-427c-8ba2-e1cb6a4435b4",
            memberId: "1945",
            memberType: "ITEM",
          },
          {
            groupId: "4bd82d48-34a4-4674-9509-88bf8f2ce383",
            id: "92952fe7-5465-4775-9410-5219efd086f9",
            memberId: "1950",
            memberType: "ITEM",
          },
        ],
      },
    ],
  },
  {
    id: "5aaa3fd1-c222-4afd-acb9-42db35384ad1",
    isActive: true,
    groups: [
      {
        groupIndex: 0,
        id: "af757907-aeac-4141-b868-d15f0956f9b0",
        members: [
          {
            groupId: "af757907-aeac-4141-b868-d15f0956f9b0",
            id: "33f3bc35-c794-4d99-9b1f-ebb06ce9d7ab",
            memberId: "1945",
            memberType: "ITEM",
          },
          {
            groupId: "af757907-aeac-4141-b868-d15f0956f9b0",
            id: "678abe2b-a5dd-4103-8962-65d6a2db7607",
            memberId: "1944",
            memberType: "ITEM",
          },
          {
            groupId: "af757907-aeac-4141-b868-d15f0956f9b0",
            id: "cbd509d7-6b94-4183-9699-46220da3fa05",
            memberId: "1943",
            memberType: "ITEM",
          },
        ],
      },
    ],
  },
  {
    id: "9c677e20-4a7b-47d0-8c22-cd3acbc8d150",
    isActive: true,
  },
  {
    id: "e51a6340-37d6-4f8c-ae6c-3752ad81cb24",
    isActive: true,
    groups: [
      {
        groupIndex: 0,
        id: "8809bc74-06c4-4799-8438-5a0bc4076916",
        members: [
          {
            groupId: "8809bc74-06c4-4799-8438-5a0bc4076916",
            id: "0fecdb8c-0e5e-460b-89d7-f0e927a6078e",
            memberId: "1944",
            memberType: "ITEM",
          },
          {
            groupId: "8809bc74-06c4-4799-8438-5a0bc4076916",
            id: "8d0bd130-6141-4b8c-b8d2-4380c7eab942",
            memberId: "1943",
          },
        ],
      },
      {
        roupIndex: 1,
        id: "401b5eda-a84c-43b2-aac6-d1acdfc0926a",
        members: [
          {
            groupId: "401b5eda-a84c-43b2-aac6-d1acdfc0926a",
            id: "a0329884-5dc3-42ae-a625-0a540f300af6",
            memberId: "1947",
            memberType: "ITEM",
          },
        ],
      },
    ],
  },
];

const output = {
  1952: {
    activeCount: 2,
    deActiveCount: 0,
    idList: ["24947d01-9fd2-4d2e-b38b-c918851eefe1"],
  },
  1951: {
    activeCount: 1,
    deActiveCount: 0,
    idList: ["24947d01-9fd2-4d2e-b38b-c918851eefe1"],
  },
  1950: {
    activeCount: 1,
    deActiveCount: 1,
    idList: [
      "24947d01-9fd2-4d2e-b38b-c918851eefe1",
      "f5c338-e870-4b78-996b-fd97360c2bb7",
    ],
  },
  1943: {
    activeCount: 2,
    deActiveCount: 1,
    idList: [
      "f5c338-e870-4b78-996b-fd97360c2bb7",
      "e51a6340-37d6-4f8c-ae6c-3752ad81cb24",
    ],
  },
  1944: {
    activeCount: 2,
    deActiveCount: 1,
    idList: [
      "f5c338-e870-4b78-996b-fd97360c2bb7",
      "e51a6340-37d6-4f8c-ae6c-3752ad81cb24",
    ],
  },
  1945: {
    activeCount: 1,
    deActiveCount: 1,
    idList: [
      "f5c338-e870-4b78-996b-fd97360c2bb7",
      "aaa3fd1-c222-4afd-acb9-42db35384ad1",
    ],
  },
  1947: {
    activeCount: 1,
    deActiveCount: 0,
    idList: ["e51a6340-37d6-4f8c-ae6c-3752ad81cb24"],
  },
};
const input2 = 1952
const input1 = {
  1952: {
    activeCount: 1,
    deActiveCount: 0,
    idList: ["24947d01-9fd2-4d2e-b38b-c918851eefe1"],
  },
  1951: {
    activeCount: 1,
    deActiveCount: 0,
    idList: ["24947d01-9fd2-4d2e-b38b-c918851eefe1"],
  },
  1950: {
    activeCount: 1,
    deActiveCount: 1,
    idList: [
      "24947d01-9fd2-4d2e-b38b-c918851eefe1",
      "f5c338-e870-4b78-996b-fd97360c2bb7",
    ],
  },
  1943: {
    activeCount: 2,
    deActiveCount: 1,
    idList: [
      "f5c338-e870-4b78-996b-fd97360c2bb7",
      "e51a6340-37d6-4f8c-ae6c-3752ad81cb24",
    ],
  },
  1944: {
    activeCount: 2,
    deActiveCount: 1,
    idList: [
      "f5c338-e870-4b78-996b-fd97360c2bb7",
      "e51a6340-37d6-4f8c-ae6c-3752ad81cb24",
    ],
  },
  1945: {
    activeCount: 1,
    deActiveCount: 1,
    idList: [
      "f5c338-e870-4b78-996b-fd97360c2bb7",
      "aaa3fd1-c222-4afd-acb9-42db35384ad1",
    ],
  },
  1947: {
    activeCount: 1,
    deActiveCount: 0,
    idList: ["e51a6340-37d6-4f8c-ae6c-3752ad81cb24"],
  },
};
/**
 * StrategyAddModal Component
 *
 * This component is responsible for rendering a modal dialog for adding, editing, or duplicating a strategy.
 * It includes fields for strategy name, delivery types (Dine In, Delivery, Takeout), and availability.
 * The user can select delivery types using switches and set availability using an availability selection component.
 * Additionally, the component provides options for canceling, saving, or creating the strategy.
 */
const StrategyAddModal: React.FunctionComponent<StrategyAddEditModalProps> = ({
  isOpen,
  setIsOpen,
  handleCreateNewStrategy,
  isLoadingButton,
  isEdit,
  isDuplicate,
  handleReset,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [expireDaysEnabled, setExpireDaysEnabled] = useState(false);
  const {
    register,
    handleSubmit,
    errors,
    reset,
    formState: { isDirty },
  } = useForm<FormData>({
    defaultValues: {
      cutOfPrice: "",
      minOrderPrice: "",
      pricePerUnit: "",
      name: "",
      daily_limits: "",
      expire_days: 0,
    },
  });

  useEffect(() => {
    reset();
    setIsActive(false);
  }, []);

  const handleSubmitData = handleSubmit(async (data: any) => {
    const formData: any = {};
    formData.cutoff_price = data.cutOfPrice;
    formData.min_order_price = data.minOrderPrice;
    formData.price_per_unit = isActive ? 1 : data.pricePerUnit;
    formData.daily_limits = parseFloat(data.daily_limits) || 0;
    formData.expire_points = expirePointsEnabled;
    formData.expire_days = data.expire_days
      ? parseFloat(data.expire_days) || 0
      : 0;
    formData.allocate_type = isActive ? "stamps" : "points";
    formData.name = data.name;

    handleCreateNewStrategy(formData);
  });

  const handleSelectPointsOrStamps = () => {
    setIsActive(!isActive);
  };

  const [dailyLimitEnabled, setDailyLimitEnabled] = useState(false);
  const [expirePointsEnabled, setExpirePointsEnabled] = useState(false);

  const handleToggleChange = () => {
    setDailyLimitEnabled(!dailyLimitEnabled);
  };

  const handleExpirePointsChange = () => {
    setExpirePointsEnabled(!expirePointsEnabled);
  };

  const handleDisable = () => {};
  return (
    <>
      <DialogCommonDefault
        open={isOpen}
        setOpen={setIsOpen}
        isNeedFixedHeight={false}
      >
        <DialogTitle>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            Add New Strategy
            <div
              style={{
                marginLeft: "12px",
              }}
            >
              <FormControlLabel
                style={{ marginLeft: "0px", marginRight: "0px" }}
                value="dinein"
                control={<SwitchCommon />}
                label={
                  <Typography variant="caption" color="textSecondary">
                    Enable Daily Limits
                  </Typography>
                }
                name="dinein"
                checked={dailyLimitEnabled}
                labelPlacement="top"
                onChange={handleToggleChange}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <Typography style={{ fontWeight: "bold" }}>
                Strategy Name
              </Typography>

              <Typography variant="caption">
                Provide a name for this strategy for easy identification in the
                future.
              </Typography>
              <div style={{ display: "flex" }}>
                <TextfieldDefaultNew
                  id="name"
                  name="name"
                  type="text"
                  inputRef={register({
                    required: "Name is required",
                    min: {
                      value: 0,
                      message: "Name cannot be negative",
                    },
                  })}
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "12px",
                  }}
                >
                  <FormControlLabel
                    style={{ marginLeft: "0px", marginRight: "0px" }}
                    value="dinein"
                    control={<SwitchCommon />}
                    label={
                      <Typography variant="caption" color="textSecondary">
                        Points
                      </Typography>
                    }
                    name="dinein"
                    checked={isActive}
                    labelPlacement="start"
                    onChange={handleSelectPointsOrStamps}
                  />
                  <Typography variant="caption" color="textSecondary">
                    Stamps
                  </Typography>
                </div>
              </div>
              {errors.name ? (
                <ValidationMessage message={errors.name.message} />
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={12} style={{ marginTop: "8px" }}>
              <Typography style={{ fontWeight: "bold" }}>
                {!isActive
                  ? "Price Cutoff for Points"
                  : "Cost of a Single Stamp"}
              </Typography>
              <Typography variant="caption">
                {!isActive
                  ? "Leave at 0.00 to allocate points for the entire order value. Otherwise, points will be allocated only up to the specified cutoff value per order."
                  : "Leave at 0.00 to allocate 1 stamp per order regardless of the order value. Otherwise, multiple stamps will be allocated based on the order value divided by this amount."}
              </Typography>
              <TextfieldDefaultNew
                id="cutOfPrice"
                name="cutOfPrice"
                type="number"
                inputRef={register({
                  required: !isActive
                    ? "Cut Of Price is required"
                    : "Stamp is required",
                  min: {
                    value: 0,
                    message: !isActive
                      ? "Cut Of Price cannot be zero or negative"
                      : "Stamp cannot be zero or negative",
                  },
                })}
              />
              {errors.cutOfPrice ? (
                <ValidationMessage message={errors.cutOfPrice.message} />
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={12} style={{ marginTop: "8px" }}>
              <Typography style={{ fontWeight: "bold" }}>
                Minimum Order Price
              </Typography>
              <Typography variant="caption">
                Specify a minimum threshold for allocating points or stamps.
                Leave at 0.00 if no minimum is required.
              </Typography>
              <TextfieldDefaultNew
                id="minOrderPrice"
                name="minOrderPrice"
                type="number"
                inputRef={register({
                  required: "Min Order Price is required",
                  min: {
                    value: 0,
                    message: "Min Order Price cannot be negative",
                  },
                })}
              />
              {errors.minOrderPrice ? (
                <ValidationMessage message={errors.minOrderPrice.message} />
              ) : (
                ""
              )}
            </Grid>
            {!isActive && (
              <Grid item xs={12} style={{ marginTop: "8px" }}>
                <Typography style={{ fontWeight: "bold" }}>
                  Points per £1 Spent
                </Typography>
                <Typography variant="caption">
                  Specify the number of points to be awarded for each £1 spent.
                  The total points will be calculated by multiplying the order
                  value by this number.
                </Typography>
                <TextfieldDefaultNew
                  id="pricePerUnit"
                  name="pricePerUnit"
                  type="number"
                  inputRef={register({
                    required: "Price Per Unit is required",
                    min: {
                      value: 0,
                      message: "Price Per Unit cannot be negative",
                    },
                  })}
                />
                {errors.pricePerUnit ? (
                  <ValidationMessage message={errors.pricePerUnit.message} />
                ) : (
                  ""
                )}
              </Grid>
            )}
            <FormControlLabel
              style={{
                marginLeft: "0px",
                marginRight: "12px",
                marginTop: "4px",
              }}
              value="dinein"
              control={<SwitchCommon />}
              label={
                <Typography variant="caption" color="textSecondary">
                  Expire Points
                </Typography>
              }
              name="dinein"
              checked={expirePointsEnabled}
              labelPlacement="start"
              onChange={handleExpirePointsChange}
            />
            {expirePointsEnabled && (
              <Grid item xs={12} style={{ marginTop: "8px" }}>
                <Typography style={{ fontWeight: "bold" }}>
                  Expire Days
                </Typography>
                <Typography variant="caption">
                  Specify the number of days after which the points will expire.
                </Typography>
                <TextfieldDefaultNew
                  id="expire_days"
                  name="expire_days"
                  type="number"
                  inputRef={register({
                    required: "Expire Days is required",
                    min: {
                      value: 0,
                      message: "Expire Days cannot be negative",
                    },
                    pattern: {
                      value: /^\d*$/, // This regex only allows digits 0-9
                      message: "Please enter a number",
                    },
                  })}
                />
                {errors.expire_days ? (
                  <ValidationMessage message={errors.expire_days.message} />
                ) : (
                  ""
                )}
              </Grid>
            )}
            {dailyLimitEnabled && (
              <Grid item xs={12} style={{ marginTop: "8px" }}>
                <Typography style={{ fontWeight: "bold" }}>
                  Daily limit
                </Typography>
                <TextfieldDefaultNew
                  id="daily_limits"
                  name="daily_limits"
                  type="number"
                  inputRef={register({
                    required: "Daily Limit is required",
                    min: {
                      value: 1,
                      message: "Daily Limit cannot be less than 1",
                    },
                    pattern: {
                      value: INTEGER_NUMBER_PATTERN,
                      message: "Please enter a Integer value",
                    },
                  })}
                />
                {errors.daily_limits ? (
                  <ValidationMessage message={errors.daily_limits.message} />
                ) : (
                  ""
                )}
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions style={{ marginBottom: "8px" }}>
          <ButtonCommon
            variant="contained"
            style={{ fontSize: 11, width: "100px", marginRight: 8 }}
            color="yellow"
            onClick={handleReset}
          >
            Cancel
          </ButtonCommon>
          <ButtonCommon
            variant="contained"
            style={{
              fontSize: 11,
              marginLeft: 4,
              width: "100px",
            }}
            disabled={handleDisable()}
            isLoadingPage={isLoadingButton}
            color={isEdit ? "orange" : isDuplicate ? "blue" : "green"}
            onClick={handleSubmitData}
          >
            {isEdit ? "Save" : isDuplicate ? "Duplicate" : "Create"}
          </ButtonCommon>
        </DialogActions>
      </DialogCommonDefault>
    </>
  );
};

export default StrategyAddModal;
